// src/components/InstallPwaButton.jsx
import { useEffect, useState } from "react";

const isIos = () => {
  if (typeof navigator === "undefined") return false;
  return /iphone|ipad|ipod/i.test(navigator.userAgent);
};

const isStandalone = () => {
  if (typeof window === "undefined") return false;

  return (
    (window.matchMedia &&
      window.matchMedia("(display-mode: standalone)").matches) ||
    window.navigator.standalone === true
  );
};

export default function usePwaInstall() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [canInstall, setCanInstall] = useState(false);
  const [ios, setIos] = useState(false);
  const [standalone, setStandalone] = useState(false);

  // Detect iOS & standalone
  useEffect(() => {
    setIos(isIos());
    setStandalone(isStandalone());
  }, []);

  // Listen for the install event
  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setCanInstall(true);
    };
    window.addEventListener("beforeinstallprompt", handler);

    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  async function triggerInstall() {
    if (ios) {
      alert("On iPhone: Share → Add to Home Screen");
      return;
    }

    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    const result = await deferredPrompt.userChoice;
    console.log("Install choice: ", result);
    setDeferredPrompt(null);
    setCanInstall(false);
  }

  return {
    canInstall: canInstall || (ios && !standalone),
    triggerInstall,
    ios,
    standalone,
  };
}
